var waitFor = require("../utils/waitFor");

waitFor(".comp-tabs", function () {
  // The class for the container div
  const $container = ".comp-tabs";

  // The setup
  $($container + " nav ul").attr("role", "tablist");
  $($container + ' [role="tablist"] li').attr("role", "presentation");
  $('[role="tablist"] a').attr({
    role: "tab",
    tabindex: "-1",
  });

  // Make each aria-controls correspond id of targeted section (re href)
  $('[role="tablist"] a').each(function () {
    $(this).attr("aria-controls", $(this).attr("href").substring(1));
  });

  // Make the first tab selected by default and allow it focus
  $('[role="tablist"] li:first-child a').attr({
    "aria-selected": "true",
    tabindex: "0",
  });

  // Make each section focusable and give it the tabpanel role
  $($container + " .tabs-panel").attr({
    role: "tabpanel",
  });

  // Make first child of each panel focusable programmatically
  $($container + " .tabs-panel > *:first-child").attr({
    tabindex: "0",
  });

  // Make all but the first section hidden (ARIA state and display CSS)
  $('[role="tabpanel"]:not(:first-of-type)').attr({
    "aria-hidden": "true",
  });

  // Change focus between tabs with arrow keys
  $('[role="tab"]').on("keydown", function (e) {
    // define current, previous and next (possible) tabs
    var $original = $(this);
    var $prev = $(this).parents("li").prev().children('[role="tab"]');
    var $next = $(this).parents("li").next().children('[role="tab"]');
    var $target;

    // find the direction (prev or next)
    switch (e.keyCode) {
      case 37:
        $target = $prev;
        break;
      case 39:
        $target = $next;
        break;
      default:
        $target = false;
        break;
    }

    if ($target.length) {
      $original.attr({
        tabindex: "-1",
        "aria-selected": null,
      });
      $target
        .attr({
          tabindex: "0",
          "aria-selected": true,
        })
        .focus();
    }

    // Hide panels
    $($container + ' [role="tabpanel"]').attr("aria-hidden", "true");

    // Show panel which corresponds to target
    $("#" + $(document.activeElement).attr("href").substring(1)).attr(
      "aria-hidden",
      null
    );
  });

  // Handle click on tab to show + focus tabpanel
  $('[role="tab"]').on("click", function (e) {
    e.preventDefault();

    if (typeof ga === "function") {
      ga(
        "gtm2.set",
        "page",
        window.location.pathname.substr(1) + $(e.currentTarget).attr("href")
      );
      ga("gtm2.send", "pageview");
    }

    switchTab(e.currentTarget);
  });

  function switchTab(tabAnchor) {
    // remove focusability [sic] and aria-selected
    $('[role="tab"]').attr({
      tabindex: "-1",
      "aria-selected": null,
    });

    // replace above on clicked tab
    $(tabAnchor).attr({
      "aria-selected": true,
      tabindex: "0",
    });

    // Hide panels
    $($container + ' [role="tabpanel"]').attr("aria-hidden", "true");

    // show corresponding panel
    $("#" + $(tabAnchor).attr("href").substring(1)).attr("aria-hidden", null);
  }

  setTimeout(function openTabFromHashValue() {
    if (!document.location.hash && document.location.hash.length === 0) return;

    var $tabEl = $('[role="tablist"] a[href="' + document.location.hash + '"]');

    if ($tabEl.length == 0) return;

    switchTab($tabEl);

    //but don't scroll to it
    window.scrollTo(0, 0);
  }, 100);

  function setupTabBump() {
    var $tabs = $('[role="tablist"]');
    var tabWidth = $tabs[0].scrollWidth;
    var winH = $(window).height();

    if ($(window).width() >= tabWidth) return;

    var tabTop = $tabs.offset().top;
    function shouldBumpTabs(e) {
      if ($(document).scrollTop() + winH > tabTop + 100) bumpTabs();
    }
    $(document).on("scroll", shouldBumpTabs);

    function bumpTabs() {
      $tabs.animate(
        {
          scrollLeft: "100px",
        },
        600
      );
      setTimeout(function () {
        $tabs.animate(
          {
            scrollLeft: 0,
          },
          400
        );
      }, 600);
      $(document).off("scroll", shouldBumpTabs);
    }
  }
  $(window).on("resize", setupTabBump);
  setTimeout(setupTabBump, 1000);
});
